/* @flow */
import { Box } from '@sonyged/proc-ui';
import styled, { css, keyframes } from 'styled-components';

import { Gender, AgeGroup } from '../../constants';
import FA01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f01@3x.png';
import FA02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f02@3x.png';
import FA03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f03@3x.png';
import FA_FIN01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f01-ﬁn@3x.png';
import FA_FIN02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f02-ﬁn@3x.png';
import FA_FIN03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f03-ﬁn@3x.png';
import FC01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f01@3x.png';
import FC02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f02@3x.png';
import FC03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f03@3x.png';
import FC_FIN01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f01-ﬁn@3x.png';
import FC_FIN02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f02-ﬁn@3x.png';
import FC_FIN03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f03-ﬁn@3x.png';
import FE01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f01@3x.png';
import FE02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f02@3x.png';
import FE03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f03@3x.png';
import FE_FIN01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f01-ﬁn@3x.png';
import FE_FIN02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f02-ﬁn@3x.png';
import FE_FIN03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f03-ﬁn@3x.png';
import MA01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m01@3x.png';
import MA02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m02@3x.png';
import MA03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m03@3x.png';
import MA_FIN01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m01-ﬁn@3x.png';
import MA_FIN02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m02-ﬁn@3x.png';
import MA_FIN03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m03-ﬁn@3x.png';
import MC01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m01@3x.png';
import MC02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m02@3x.png';
import MC03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m03@3x.png';
import MC_FIN01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m01-ﬁn@3x.png';
import MC_FIN02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m02-ﬁn@3x.png';
import MC_FIN03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m03-ﬁn@3x.png';
import ME01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m01@3x.png';
import ME02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m02@3x.png';
import ME03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m03@3x.png';
import ME_FIN01 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m01-ﬁn@3x.png';
import ME_FIN02 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m02-ﬁn@3x.png';
import ME_FIN03 from '../../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m03-ﬁn@3x.png';

const offsets = {
  middle: '40%',
  left: '20%',
  right: '60%',
};

const imgs = {
  [Gender.MALE]: {
    [AgeGroup.CHILD]: { '1': MC01, '2': MC02, '3': MC03 },
    [AgeGroup.ADULT]: { '1': MA01, '2': MA02, '3': MA03 },
    [AgeGroup.MIDDLE_AGE]: { '1': ME01, '2': ME02, '3': ME03 },
  },
  [Gender.FEMALE]: {
    [AgeGroup.CHILD]: { '1': FC01, '2': FC02, '3': FC03 },
    [AgeGroup.ADULT]: { '1': FA01, '2': FA02, '3': FA03 },
    [AgeGroup.MIDDLE_AGE]: { '1': FE01, '2': FE02, '3': FE03 },
  },
};

const finImgs = {
  [Gender.MALE]: {
    [AgeGroup.CHILD]: { '1': MC_FIN01, '2': MC_FIN02, '3': MC_FIN03 },
    [AgeGroup.ADULT]: { '1': MA_FIN01, '2': MA_FIN02, '3': MA_FIN03 },
    [AgeGroup.MIDDLE_AGE]: { '1': ME_FIN01, '2': ME_FIN02, '3': ME_FIN03 },
  },
  [Gender.FEMALE]: {
    [AgeGroup.CHILD]: { '1': FC_FIN01, '2': FC_FIN02, '3': FC_FIN03 },
    [AgeGroup.ADULT]: { '1': FA_FIN01, '2': FA_FIN02, '3': FA_FIN03 },
    [AgeGroup.MIDDLE_AGE]: { '1': FE_FIN01, '2': FE_FIN02, '3': FE_FIN03 },
  },
};

const hopping = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, -2%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

const CustomerBase = styled(Box)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'auto 100%',
  width: '20%',
});

export const Customer = styled(CustomerBase)(
  ({ sit = 'middle', ageGroup = AgeGroup.CHILD, gender = Gender.MALE, kind = 1, isFinish = false }) => ({
    left: offsets[sit],
    backgroundImage: isFinish ? `url('${finImgs[gender][ageGroup][kind]}')` : `url('${imgs[gender][ageGroup][kind]}')`,
  }),
  ({ animating = false }) =>
    animating
      ? css`
          animation: ${hopping} 0.3s 2;
        `
      : ''
);
